// src/Berichte.js
import React from 'react';
import './Berichte.css';
import './components.css';

function Berichte() {
  return (
    <div className="berichte-container">
      <h1>Berichte</h1>
      <div className="content-card">
        <p>Diese Komponente wird derzeit überarbeitet.</p>
      </div>
    </div>
  );
}

export default Berichte;
